import { createSelector } from "reselect";
import _ from "lodash";
export const getUsers = ({ UserManager_reducer }) => {
    return UserManager_reducer.users;
};
export const getQualifications = ({ UserManager_reducer }) => {
    return UserManager_reducer.qualifications;
};
export const selectUsersRequesting = ({ UserManager_reducer }) => {
    return UserManager_reducer.requesting;
};
export const selectRemovingUser = ({ UserManager_reducer }) => {
    return UserManager_reducer.removedUser;
};
export const selectUserIsRemoved = createSelector(
    [selectRemovingUser],
    removing => {
        return removing;
    }
);
export const selectRegisteredUsers = createSelector(
    [getUsers],
    users => {
        if (users === false || typeof users === "undefined" || users === null) {
            return [];
        }

        let regUsers = Object.keys(users).map(e => {
            return _.get(users[e], "profile");
        });
        regUsers = _.orderBy(regUsers, ["first_name"], ["asc"]);
        return regUsers.filter(e => {
            if (e.deleted !== true) {
                return true;
            } else {
                return false;
            }
        });
    }
);
export const selectQualifications = createSelector(
    [getQualifications],
    qualifications => {
        if (
            qualifications === false ||
            typeof qualifications === "undefined" ||
            qualifications === null
        ) {
            return [];
        }

        let regQualifications = Object.keys(qualifications).map(e => {
            return qualifications[e];
        });

        return regQualifications;
    }
);
